import type { SVGProps } from "react";

export default function CartIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 381.06 337.13"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				{/* Black parts - use currentColor so they can be controlled via CSS */}
				<path
					fill="currentColor"
					d="M60.53,108.57c6.38-2.51,12.61-2.47,19,0,73.97-.27,148.03-.27,222,0,6.39-2.47,12.62-2.51,19,0,13.26.08,29.7-1.27,42.49.01,7.67.77,15.96,6.92,17.27,14.73,1.07,6.37.88,23.06.28,29.8-.57,6.32-4.1,13.29-10.03,15.97-2.45,1.11-9.25,1.54-10.01,3.23-11.57,46.91-21.67,94.27-33.69,141.08-1.49,5.81-3.69,21.99-9.27,23.73H63.48c-3.03-1.13-4.43-3.75-5.25-6.75L20.33,171.78c-11.07-1.7-18.78-6.7-19.84-18.67-.6-6.74-.79-23.43.28-29.8,1.31-7.81,9.6-13.96,17.27-14.73,12.78-1.28,29.22.07,42.49-.01ZM363.53,125.57H17.53v29h346v-29ZM100.53,171.57h-63l16.5,66h54.5l-8-66ZM182.53,171.57h-65l8,66h57v-66ZM263.53,171.57h-65v66h57l8-66ZM343.53,171.57h-63l-8,66h54.5l16.5-66ZM110.53,254.57h-53l16.5,67h45.5l-9-67ZM182.53,254.57h-55l8,67h47v-67ZM253.53,254.57h-55v67h47l8-67ZM323.53,254.57h-53l-9,67h46l16-67Z"
				/>
				{/* Green parts - keep fixed color */}
				<path fill="#3fdfcf" d="M79.53,108.57c-6.32.02-12.68-.04-19,0L114.37,5.91c4.36-10.7,18.77-5.7,15.69,5.69-16.53,32.47-34.88,64.08-50.53,96.97Z" />
				<path fill="#3fdfcf" d="M320.53,108.57c-6.32-.04-12.68.02-19,0-15.72-32.85-34.08-64.45-50.52-96.97-3.11-11.36,10.38-16.2,15.72-5.73l53.8,102.69Z" />
			</g>
		</svg>
	);
}

